import { render } from "./BaseSpinner.vue?vue&type=template&id=50c886a0&scoped=true"
const script = {}

import "./BaseSpinner.vue?vue&type=style&index=0&id=50c886a0&scoped=true&lang=css"

import exportComponent from "D:\\Dwiki\\learn-vue\\vue-cli\\practice\\coach-vue\\coach-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50c886a0"]])

export default __exports__